import React, { useState } from 'react';
import axios from 'axios';
import '../../css/admin/admin.css';

/* ── Demo credentials (works without backend) ── */
const DEMO_ADMIN = {
  id:    'demo-001',
  name:  'Super Admin',
  email: 'admin@theeliteglobalreview.com',
  role:  'super',
  avatar:'',
};
const DEMO_EMAIL    = 'admin@theeliteglobalreview.com';
const DEMO_PASSWORD = 'Admin@2026';
const DEMO_TOKEN    = 'demo-token-elite-2026';

const LogoSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 48" width="220" height="34">
    <rect fill="#c9a84c" x="0" y="0" width="3" height="48"/>
    <text fontFamily="'Playfair Display',Georgia,serif" fontWeight="700" fontSize="20"
      fill="#ffffff" x="12" y="32">
      The Elite <tspan fill="#c9a84c">Global</tspan> Review
    </text>
    <text fontFamily="'DM Sans',Arial,sans-serif" fontSize="8"
      fill="rgba(255,255,255,0.45)" x="12" y="44" letterSpacing="2.5">
      ADMIN PORTAL
    </text>
  </svg>
);

export default function AdminLogin({ onLogin }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [show,     setShow]     = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    /* ── Step 1: try real backend ── */
    try {
      const res = await axios.post('/api/admin/login', { email, password }, { timeout: 4000 });
      if (res.data?.token && res.data?.admin) {
        localStorage.setItem('adminToken', res.data.token);
        localStorage.setItem('adminUser',  JSON.stringify(res.data.admin));
        localStorage.setItem('adminMode',  'live');
        onLogin(res.data.admin, res.data.token);
        return;
      }
    } catch (apiErr) {
      /* backend not running or creds wrong — check if it's a credentials error */
      const status = apiErr.response?.status;
      /* If server responded 401, credentials are genuinely wrong */
      if (status === 401) {
        setError(apiErr.response.data?.message || 'Invalid email or password.');
        setLoading(false);
        return;
      }
      /* Any other error (network, 404, 500) → fall through to demo mode */
    }

    /* ── Step 2: demo / offline mode ── */
    await new Promise(r => setTimeout(r, 600)); // small delay for realism
    if (
      email.toLowerCase().trim()    === DEMO_EMAIL.toLowerCase() &&
      password === DEMO_PASSWORD
    ) {
      localStorage.setItem('adminToken', DEMO_TOKEN);
      localStorage.setItem('adminUser',  JSON.stringify(DEMO_ADMIN));
      localStorage.setItem('adminMode',  'demo');
      onLogin(DEMO_ADMIN, DEMO_TOKEN);
    } else {
      setError('Invalid email or password. Use: admin@theeliteglobalreview.com / Admin@2026');
    }

    setLoading(false);
  };

  return (
    <div className="admin-login">
      <div className="login-bg"/>
      <div className="login-glow"/>

      <div className="login-card">
        <div className="login-logo"><LogoSVG/></div>
        <h1 className="login-title">Welcome back</h1>
        <p className="login-sub">Sign in to manage content, uploads, and subscribers.</p>

        <form className="login-form" onSubmit={handleSubmit} noValidate>

          <div className="form-group">
            <label className="form-label" htmlFor="adm-email">Email Address</label>
            <input
              id="adm-email"
              className="form-input"
              type="email"
              placeholder="xyz@gmail.com"
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); }}
              required
              autoFocus
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="adm-pass">Password</label>
            <div style={{ position:'relative' }}>
              <input
                id="adm-pass"
                className="form-input"
                type={show ? 'text' : 'password'}
                placeholder="••••••••"
                value={password}
                onChange={e => { setPassword(e.target.value); setError(''); }}
                required
                autoComplete="current-password"
                style={{ paddingRight: 48 }}
              />
              <button
                type="button"
                onClick={() => setShow(s => !s)}
                title={show ? 'Hide password' : 'Show password'}
                style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)',
                  background:'none', border:'none', color:'var(--white40)',
                  cursor:'pointer', fontSize:'1rem', lineHeight:1, padding:4 }}
              >
                {show ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {error && (
            <div style={{ padding:'11px 14px', background:'rgba(248,113,113,.08)',
              borderRadius:4, border:'1px solid rgba(248,113,113,.22)',
              fontSize:'.83rem', color:'#f87171', lineHeight:1.5 }}>
              {error}
            </div>
          )}

          <button
            className="btn btn-primary"
            type="submit"
            disabled={loading}
            style={{ width:'100%', padding:'13px', justifyContent:'center',
              fontSize:'.9rem', marginTop:4, letterSpacing:'.05em' }}
          >
            {loading
              ? <span style={{ display:'flex', alignItems:'center', gap:8, justifyContent:'center' }}>
                  <span style={{ width:14, height:14, border:'2px solid rgba(13,13,13,.3)',
                    borderTopColor:'var(--bg)', borderRadius:'50%',
                    animation:'spin .7s linear infinite', display:'inline-block' }}/>
                  Signing in…
                </span>
              : 'Sign In to Dashboard'
            }
          </button>
        </form>

        {/* Credentials hint */}
        <div className="login-footer" style={{ marginTop:20 }}>
          {/* <div style={{ background:'rgba(201,168,76,.07)', border:'1px solid rgba(201,168,76,.18)',
            borderRadius:4, padding:'10px 14px', textAlign:'left' }}>
            <div style={{ fontSize:'.7rem', fontWeight:700, letterSpacing:'.1em',
              textTransform:'uppercase', color:'var(--gold)', marginBottom:6 }}>
              Default Credentials
            </div>
            <div style={{ fontSize:'.78rem', color:'var(--white70)', lineHeight:1.7 }}>
              📧 admin@theeliteglobalreview.com<br/>
              🔑 Admin@2026
            </div>
          </div> */}
        </div>
      </div>

      {/* Spinner keyframe */}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
